
import './App.css';

// importar componentes
import { NasaList } from './components/NasaList';

function App() {
  return (
    <div className="App">

      <NasaList/>

    </div>
  );
}

export default App;
